import React, { useEffect, useState } from "react";
import { Pencil, Trash2 } from "lucide-react";
import { AvatarCharecter, AvatarImage, CenteredModal, LargeModal, Pagination } from "components";
import { useApp, useCommon, useMember } from "hooks";
import { EActionUserModal } from "types";
import UserForm from "./UserForm";
import { repareURL } from "utils";

export default function Users() {
    const [currentPage, setCurrentPage] = useState(1);

    const { createMember, updateMember, delMember } = useMember();

    const { onUpdateParams, userData, userCurrentPage, userIsFetch } = useApp();

    const [dataTable, setDataTable] = useState({
        data: [],
        totalPage: 1,
    });

    useEffect(() => {
        currentPage !== userCurrentPage && onUpdateParams({ userCurrentPage: currentPage })
    }, [currentPage, userCurrentPage]);

    useEffect(() => {
        if (userData?.data) {
            setDataTable(userData);
        }
    }, [userData]);


    const actionsUserState = useCommon(state => state.actionsUserState)
    const { setActionsUserState } = useCommon();
    const { trans } = useApp();

    const onClose = () => {
        setActionsUserState(null);
    }

    const handleIsFetch = () => {
        onUpdateParams({ userIsFetch: !userIsFetch })
    }

    const handleSubmit = ({ root }) => {
        console.log("🚀 ~ handleSubmit ~ root:", root)
        switch (actionsUserState?.method) {
            case EActionUserModal.CREATE:
                createMember.mutate(root, {
                    onSuccess: (res) => {
                        console.log("🚀 ~ handleSubmit ~ res:", res)
                        onClose();
                        handleIsFetch();
                    },
                });
                break;
            case EActionUserModal.EDIT:
                updateMember.mutate(root, {
                    onSuccess: (res) => {
                        console.log("🚀 ~ handleSubmit ~ res:", res)
                        onClose();
                        handleIsFetch();
                    },
                });
                break;
            case EActionUserModal.DELETE:
                delMember.mutate({ id: actionsUserState.item.id }, {
                    onSuccess: (res) => {
                        console.log("🚀 ~ handleSubmit ~ res:", res)
                        onClose();
                        handleIsFetch();
                    },
                });
                break;
            default:
                break;
        }

    }

    return (
        <div className=" bg-gray-50 min-h-screen mt-10">
            <div className="overflow-x-auto bg-white rounded-xl shadow">
                {!!dataTable?.data.length && <table className="min-w-full table-auto">
                    <thead className="bg-gray-100 text-gray-700 text-sm">
                        <tr>
                            <th className="p-3 text-left">Tên </th>
                            <th className="p-3 text-left">Email</th>
                            <th className="p-3 text-left">isAdmin</th>
                            <th className="p-3 text-left">Ngày tạo</th>
                            <th className="p-3 text-left">Status</th>
                            <th className="p-3 text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm text-gray-600">
                        {dataTable.data.map((mem) => (
                            <tr key={mem.id} className="border-t hover:bg-gray-50 border-gray-200">
                                <td className="p-3 flex items-center gap-3">
                                    {mem.avatar ? <AvatarImage src={repareURL(mem.avatar)} alt={mem?.name} className="w-8 h-8 rounded-full" /> : <AvatarCharecter className="w-8 h-8" name={mem?.name} />}
                                    {mem.name}
                                </td>
                                <td className="p-3">{mem.email}</td>
                                <td className="p-3">{mem.isAdmin ? <span className={`px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-600`}>
                                    admin
                                </span> : <></>}
                                </td>
                                <td className="p-3">{mem.created_at}</td>
                                <td className="p-3">
                                    <span className={`px-2 py-1 rounded text-xs font-medium ${!(+mem.status)
                                        ? "bg-green-100 text-green-600"
                                        : "bg-red-100 text-red-500"
                                        }`}>
                                        {!(+mem.status) ? 'Activate' : 'Locked'}
                                    </span>
                                </td>
                                <td className="p-3 flex justify-center gap-2 text-gray-500">
                                    <Pencil className="w-4 h-4 cursor-pointer hover:text-blue-600" onClick={() => setActionsUserState({ method: EActionUserModal.EDIT, item: mem })} />
                                    <Trash2 className="w-4 h-4 cursor-pointer hover:text-red-600" onClick={() => setActionsUserState({ method: EActionUserModal.DELETE, item: mem })} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>}
            </div>

            {dataTable?.totalPage > 1 && <div className="flex items-center justify-between mt-4 text-sm text-gray-500">
                <span></span>
                <div className="space-x-2">
                    <Pagination currentPage={currentPage} totalPages={dataTable?.totalPage} onPageChange={(p) => setCurrentPage(p)} />
                </div>
            </div>}
            {actionsUserState?.method === EActionUserModal.DELETE &&
                <CenteredModal
                    title={`${trans(actionsUserState?.method)} thành viên`}
                    description="Bạn có chắc muốn xoá thành viên này không?"
                    type={'delete'}
                    onClose={onClose}
                    onConfirm={() => handleSubmit({ root: null })} />}

            {(actionsUserState?.method === EActionUserModal.CREATE || actionsUserState?.method === EActionUserModal.EDIT) && (
                <LargeModal title={`${trans(actionsUserState?.method)} thành viên`} onClose={onClose} >
                    <UserForm onClose={onClose} onConfirm={handleSubmit} />
                </LargeModal>)}
        </div>
    );
}
